import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { destinations } from '../../data/tourData';
import './DestinationsSection.css';

const DestinationsSection = () => {
  return (
    <section className="destinations">
      <div className="container">
        <div className="section-header">
          <motion.h2 
            className="section-title"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            Explore Top Destination
          </motion.h2>
          <motion.p 
            className="section-subtitle"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Discover breathtaking landscapes and unforgettable adventures
          </motion.p>
        </div>
        
        <div className="destinations-grid">
          {destinations.map((destination, index) => (
            <motion.div
              key={destination.id}
              className="destination-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <Link to={destination.link}>
                <img src={destination.image} alt={destination.name} />
                <div className="destination-content">
                  <h3>{destination.name}</h3>
                  <p>{destination.places} Place{destination.places !== 1 ? 's' : ''}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DestinationsSection;
